export default "__VITE_ASSET__aaDSWDAM__"